import React from "react";
type SocialIconProps = {
  id: "facebook" | "instagram" | "group";
  className?: string;
};
export function SocialIcon({
  id,
  className = "h-5 w-5"
}: SocialIconProps) {
  if (id === "instagram") {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} className={className} aria-hidden="true" data-id="element-241" data-mp="3ogv1k0jk6f7m">
        <rect x="3" y="3" width="18" height="18" rx="5" data-id="element-242" data-mp="3jjle2qfqcdmf" />
        <circle cx="12" cy="12" r="4" data-id="element-243" data-mp="2vsfnphc5y2xv" />
        <circle cx="17.5" cy="6.5" r="0.9" fill="currentColor" stroke="none" data-id="element-244" data-mp="2vthceom3qny2" />
      </svg>;
  }
  if (id === "group") {
    return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" className={className} aria-hidden="true" data-id="element-245" data-mp="34tnllyarp1rf">
        <circle cx="9" cy="8" r="3.2" data-id="element-246" data-mp="30qqx5qyjqbfk" />
        <path d="M3 19c.6-3.2 3-5 6-5s5.4 1.8 6 5" data-id="element-247" data-mp="k3ofluda92rg" />
        <circle cx="17" cy="9" r="2.4" data-id="element-248" data-mp="k2dbftfxdszt" />
        <path d="M16.5 14.2c2.3.2 4 1.7 4.5 4.3" data-id="element-249" data-mp="k5j3nhjupazr" />
      </svg>;
  }
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-250" data-mp="g45vh0tacvpo">
      <path d="M13.5 21v-7.5h2.5l.4-3h-2.9V8.6c0-.9.3-1.5 1.5-1.5h1.5V4.4c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v2.4H8v3h2.6V21h2.9z" data-id="element-251" data-mp="2tpbc437dxzlq" />
    </svg>;
}